import type { SubscriptionViewSignature } from '@efdigital/ll-addon-content/types/components/parts/subscription-view';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const SubscriptionView: TemplateOnlyComponent<SubscriptionViewSignature> =
  <template>
    <div ...attributes>{{yield}}</div>
  </template>;

export { SubscriptionView };
